import { Component, OnInit, Input } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { ChangeDetectorRef } from "@angular/core";
import {
	UntypedFormGroup,
	UntypedFormControl,
} from "@angular/forms";
import { RequestForm } from "../../../../partials/form-state/form-state.component";

@Component({
	selector: "user-web-teams",
	templateUrl: "./user-web-teams.component.html",
})
export class UserWebTeamsComponent implements OnInit {
	@Input() user: any;
	allWebTeams: any[] = [];

	form = new RequestForm(
		false,
		new UntypedFormGroup({
			webTeamId: new UntypedFormControl(""),
		})
	);

	constructor(private http: HttpClient, private change: ChangeDetectorRef) {}

	ngOnInit() {
		this.http.get("/api/web-teams").subscribe(
			(teams: any[]) => {
				this.allWebTeams = teams;
				this.change.detectChanges();
			}
		);
	}

	availableTeams(): any[] {
		return this.allWebTeams.filter(
			(t) => !this.user.webTeamMemberships?.some((m: any) => m.webTeam?.id === t.id)
		);
	}

	addWebTeam() {
		if (this.form.working) return;
		this.form.setWorking();
		this.http
			.post(`/api/users/${this.user.id}/web-teams`, this.form.getValue())
			.subscribe(
				(response: any) => {
					if (!this.user.webTeamMemberships) this.user.webTeamMemberships = [];
					this.user.webTeamMemberships.push(response);
					this.form.reset();
				},
				(error) => this.form.setError(error.error)
			)
			.add(() => this.change.detectChanges());
	}

	removeWebTeam(membership: any) {
		if (this.form.working) return;
		this.form.setWorking();
		this.http
			.delete(`/api/users/${this.user.id}/web-teams/${membership.webTeam.id}`)
			.subscribe(
				() => {
					const index = this.user.webTeamMemberships.indexOf(membership, 0);
					if (index > -1) this.user.webTeamMemberships.splice(index, 1);
					this.form.reset();
				},
				(error) => this.form.setError(error.error)
			)
			.add(() => this.change.detectChanges());
	}
}
